import { HttpService } from '../../services/services.index';
import { IEntity } from '../../domain/entity.interface';
import { EEndpoint } from '../../config/endpoint.config';
import { AxiosResponse } from 'axios';
import { IWish, IWishFind } from '../../domain/wish.interface';
import {
  ENotification,
  INotification,
} from '../../domain/notification.interface';
import { returnNotification } from '../render-controller/render-controller.actions';
import history from '../../store/history/history';
import { ERoutes } from '../../assets/constants/routes';
import { replacePathParams } from '../../utils/NavigateWithParams';

export const WISHLISTCATALOGUE_LOADED = 'WISHLISTCATALOGUE_LOADED';
export const WISHLIST_LOADED = 'WISHLIST_LOADED';
export const WISH_LOADED = 'WISH_LOADED';
export const WISHLIST_SHARED = 'WISHLIST_SHARED';

const httpService = new HttpService();

export const loadWishListCatalogue = () => {
  return (dispatch: any) => {
    httpService
      .get(EEndpoint.WISH_LIST_CATALOGUE)
      .then((res: AxiosResponse<IEntity[]>) => {
        dispatch({
          type: WISHLISTCATALOGUE_LOADED,
          payload: res,
        });
      });
  };
};

export const loadWishList = (wishlistId: string) => {
  return (dispatch: any) => {
    httpService
      .get(EEndpoint.WISH_LIST, { params: { wishlistId: wishlistId } })
      .then((res: AxiosResponse<IEntity[]>) => {
        dispatch({
          type: WISHLIST_LOADED,
          payload: res,
        });
      });
  };
};

export const loadWish = (wishId: string) => {
  return (dispatch: any) => {
    httpService
      .get(EEndpoint.WISH_ID, { params: { wishId: wishId } })
      .then((res: AxiosResponse<IWish>) => {
        dispatch({
          type: WISH_LOADED,
          payload: res,
        });
      });
  };
};

export const resetWish = () => {
  return {
    type: WISH_LOADED,
    payload: {},
  };
};

export const newWishList = (body: any) => {
  return (dispatch: any) => {
    httpService.post(EEndpoint.WISH_LIST_CATALOGUE, body).then(() => {
      dispatch(loadWishListCatalogue());
    });
  };
};

export const newWish = (body: any, images: any, wishlistId: string) => {
  return async (dispatch: any) => {
    const newBody = body;
    newBody['wishListId'] = wishlistId;
    const res: any = await httpService.post(EEndpoint.WISH, newBody);

    if (images.hasOwnProperty('main_photo')) {
      await httpService.post(
        EEndpoint.WISH_MAIN_PHOTO_UPLOAD,
        images['main_photo'],
        {
          params: { wishId: res.id },
        },
      );
    }

    if (images.hasOwnProperty('optional_photos')) {
      await httpService.post(
        EEndpoint.WISH_OPTIONAL_PHOTO_UPLOAD,
        images['optional_photos'],
        { params: { wishId: res.id } },
      );
    }

    history.push(
      replacePathParams(ERoutes.WISH_LIST, { wishListId: wishlistId }),
    );
  };
};

export const editWish = (
  body: any,
  images: any,
  imagesToRemove: string[] | undefined,
  wishId: string,
  wishlistId?: string,
) => {
  return async (dispatch: any) => {
    const res: any = await httpService.put(EEndpoint.WISH_ID, body, {
      params: { wishId: wishId },
    });

    if (!res) {
      return;
    }

    if (images.hasOwnProperty('main_photo')) {
      await httpService.post(
        EEndpoint.WISH_MAIN_PHOTO_UPLOAD,
        images['main_photo'],
        {
          params: { wishId: res.id },
        },
      );
    }

    if (images.hasOwnProperty('optional_photos')) {
      await httpService.post(
        EEndpoint.WISH_OPTIONAL_PHOTO_UPLOAD,
        images['optional_photos'],
        { params: { wishId: res.id } },
      );
    }

    if (!!imagesToRemove && !!imagesToRemove.length) {
      await httpService.post(
        EEndpoint.WISH_OPTIONAL_PHOTO_DELETE_MANY,
        { ids: imagesToRemove },
        { params: { wishId: wishId } },
      );
    }

    history.push(
      replacePathParams(ERoutes.WISH_LIST, { wishListId: wishlistId }),
    );
  };
};

export const shareWish = (body: any, wishId: string) => {
  return httpService.post(EEndpoint.SHARE_WISH, body, {
    params: { wishId: wishId },
  });
};

export const patchStatusWish = (wishlistId: string, wishId: string) => {
  return (dispatch: any) => {
    httpService
      .patch(EEndpoint.WISH_BOOKED, {}, { params: { wishId } })
      .then(() => {
        dispatch(loadWishList(wishlistId));
      });
  };
};

export const copyWish = (wishId: string) => {
  return async (dispatch: any) => {
    await httpService.post(EEndpoint.WISH_COPY, {}, { params: { wishId } });
    const notification: INotification = {
      type: ENotification.SUCCESS,
      msg1: 'success.copyWish',
    };
    dispatch(returnNotification(notification));
  };
};

export const getWishListAuthUsers = (wishListId: string) =>
  httpService
    .get(EEndpoint.WISH_LIST_AUTH, {
      params: { wishListId: wishListId },
    })
    .then((res: any) => res);

export const addWishListAuthUsers = (body: any, wishListId: string) => {
  body.map((userId: string) => {
    return httpService.post(
      EEndpoint.WISH_LIST_AUTH,
      { userId },
      { params: { wishListId: wishListId } },
    );
  });
};

export const removeWishListAuthUser = (wishListId: string, userId: string) => {
  return httpService.delete(EEndpoint.REMOVE_WISH_LIST_AUTH, {
    params: { wishListId: wishListId, userId: userId },
  });
};

export const deleteWishList = (wishlistId: any) => {
  return (dispatch: any) => {
    httpService
      .delete(EEndpoint.WISH_LIST, { params: { wishlistId: wishlistId } })
      .then(() => {
        dispatch(loadWishListCatalogue());
      });
  };
};

export const deleteWish = (wishlistId: string, wishId: string) => {
  return (dispatch: any) => {
    httpService
      .delete(EEndpoint.WISH_ID, { params: { wishId: wishId } })
      .then(() => {
        dispatch(loadWishList(wishlistId));
      });
  };
};

export const resetWishListCatalogue = () => {
  return (dispatch: any) => {
    dispatch({
      type: WISHLISTCATALOGUE_LOADED,
      payload: [],
    });
  };
};

export const resetWishList = () => {
  return (dispatch: any) => {
    dispatch({
      type: WISHLIST_LOADED,
      payload: {},
    });
  };
};

export const createSharableLink = (wishlistId: string) => {
  return (dispatch: any) => {
    httpService
      .post(
        EEndpoint.WISH_LIST_SHARE,
        {},
        { params: { wishlistId: wishlistId } },
      )
      .then((res: AxiosResponse<IEntity[]>) => {
        dispatch({
          type: WISHLIST_SHARED,
          payload: res,
        });
      });
  };
};

export const findWishesByText = (text: string): Promise<IWishFind[]> =>
  httpService.get(EEndpoint.WISH_FIND, {
    params: { text: text, limit: 100 },
  }) as any;
